import {Em2EnquiryTypeMappingDTO, Em2EnquiryTypeMappingDTOEventTypeEnum, Em2EnquiryVehicle} from "../../../../../../api/generated";
import {em2EnquiryTypes} from "../types/em2EnquiryTypes";

// The API returns `vehicle: null` for mappings without a vehicle, while field configs leave it undefined.
const matches = (
    mapping: Em2EnquiryTypeMappingDTO,
    eventType: Em2EnquiryTypeMappingDTOEventTypeEnum,
    vehicle?: Em2EnquiryVehicle | null
) => mapping.eventType === eventType && (mapping.vehicle ?? null) === (vehicle ?? null);

// Keeps only the latest mapping per event type and vehicle; earlier saves appended duplicates.
export const dedupeEnquiryTypeMappings = (
    mappings: Em2EnquiryTypeMappingDTO[] | undefined
): Em2EnquiryTypeMappingDTO[] =>
    (mappings || []).filter((mapping, index, all) =>
        !all.slice(index + 1).some(later => matches(later, mapping.eventType, mapping.vehicle)));

export const findEnquiryTypeMapping = (
    mappings: Em2EnquiryTypeMappingDTO[] | undefined,
    eventType: Em2EnquiryTypeMappingDTOEventTypeEnum,
    vehicle?: Em2EnquiryVehicle
): Em2EnquiryTypeMappingDTO | undefined =>
    (mappings || []).find(mapping => matches(mapping, eventType, vehicle));

export const setEnquiryTypeMapping = (
    mappings: Em2EnquiryTypeMappingDTO[] | undefined,
    eventType: Em2EnquiryTypeMappingDTOEventTypeEnum,
    vehicle: Em2EnquiryVehicle | undefined,
    enquiryTypeId: number | undefined
): Em2EnquiryTypeMappingDTO[] => {
    const others = (mappings || []).filter(mapping => !matches(mapping, eventType, vehicle));
    const enquiryType = em2EnquiryTypes.find(type => type.id === enquiryTypeId);
    if (!enquiryType) {
        return others;
    }

    return [
        ...others,
        {
            eventType,
            ...(vehicle && {vehicle}),
            enquiryTypeId: enquiryType.id,
            enquiryTypeName: enquiryType.name
        }
    ];
};
